<div class="container-fluid">
    <mat-toolbar>
        <span>File Upload & Download</span>
        <span class="fill-remaining-space"></span>
        <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
      </mat-toolbar>

      <br>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-5">
                  <label class="btn btn-default p-0">
                    <input type="file" class="form-control" (change)="selectFile($event)" />
                  </label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control"  [(ngModel)]="description" placeholder="Description">
                </div>   
                <div class="col-2">
                  <button *ngIf="crud_access.create"  class="btn btn-success btn-sm" [disabled]="!selectedFiles || !description" (click)="upload()">
                    Upload
                  </button>
                </div>
              </div>
              
              <div *ngIf="currentFile" class="progress my-3">
                <div
                  class="progress-bar progress-bar-info progress-bar-striped"
                  role="progressbar"
                  attr.aria-valuenow="{{ progress }}"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  [ngStyle]="{ width: progress + '%' }"
                >
                  {{ progress }}%
                </div>
              </div>
                  
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">          
            <table class="table table-sm mt-2 table-bordered">  
                <thead>
                  <tr>   
                    <th style="width: 30%"  scope="col">File Name</th>
                    <th style="width: 24%"  scope="col">Description</th>
                    <th style="width: 15%"  scope="col">Attached On</th>
                    <th style="width: 18%"  scope="col">CreatedBy</th>
                    <th style="width: 13%"  scope="col">Action</th>
                  </tr>
                  </thead>    
                  <tbody>                    
                     <tr *ngFor="let item of attachmentList; let i = index">              
                        <td class="d-none">{{ item.RefNo }}</td>
                        <td>{{ item.FileName }}</td>
                        <td>{{ item.Description }}</td>
                        <td>{{ item.AttachedDate | date :'y-MM-dd'}}</td>
                        <td>{{ item.CreatedBy }}</td> 
                        <td>
                          <button *ngIf="crud_access.read"  (click)="downloadBtnClick(item)" class="btn btn-success btn-sm text-white"><i class="fa fa-download"></i></button>
                          <button *ngIf="crud_access.delete"  (click)="deleteBtnClick(item)" class="btn btn-danger btn-sm ml-1 text-white"><i class="far fa-trash-alt"></i></button>
                        </td>
                    </tr> 
                    <tr *ngIf="attachmentList.length===0">
                      <td colspan="5" class="text-center" style="font-style: italic;">No files available in table</td>
                    </tr>                     
                                                                          
                  </tbody>
              </table> 
        </div> 


    </div>
</div>
